"use client";

import { c as _c } from "react/compiler-runtime";
import { useNinetailed } from "@ninetailed/experience.js-react";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * The Next.js App Router does not fire Ninetailed page events automatically
 * (unlike the Pages Router), so we send one on each pathname change to keep
 * the visitor profile — and therefore audience membership — up to date.
 */
export function NinetailedPageTracker() {
  const $ = _c(4);
  const ninetailed = useNinetailed();
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] !== ninetailed || $[1] !== pathname) {
    t0 = () => {
      ninetailed.page({
        path: pathname
      });
    };
    t1 = [ninetailed, pathname];
    $[0] = ninetailed;
    $[1] = pathname;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}